"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INITIAL_STATE = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _errorCodeConstants = _interopRequireDefault(require("../../../constants/errorCodeConstants"));
var _address = require("../../../utils/address/address");
var _replaceStringVars = _interopRequireDefault(require("../../../utils/string/replaceStringVars"));
var _addressActionConstants = require("../../actions/address/addressActionConstants");
var _addressSearchActionConstants = require("../../actions/addressSearch/addressSearchActionConstants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
var INITIAL_STATE = exports.INITIAL_STATE = {
  addressSearchComplete: false,
  addresses: [],
  findAddressError: undefined,
  showAddressForm: false,
  showAddressSearchForm: true,
  internationalMode: false,
  initialValues: undefined
};

// eslint-disable-next-line consistent-return
var findAddressErrorBodyText = function findAddressErrorBodyText(FIND_ADDRESS_ERROR, postcode) {
  var bodyText = (0, _get["default"])(FIND_ADDRESS_ERROR, 'body');
  if (bodyText) {
    if ((0, _isArray["default"])(bodyText)) {
      return [bodyText[0], _objectSpread(_objectSpread({}, bodyText[1]), {}, {
        postcode: postcode
      })];
    }
    return (0, _replaceStringVars["default"])(bodyText, {
      postcode: postcode
    });
  }
};
var addressHigherOrderReducer = function addressHigherOrderReducer(_ref) {
  var CUSTOM_STATE = _ref.CUSTOM_STATE,
    ADDRESS_ID = _ref.ADDRESS_ID,
    FIND_ADDRESS_ERROR = _ref.FIND_ADDRESS_ERROR,
    ADDRESS_SEARCH_ERROR = _ref.ADDRESS_SEARCH_ERROR;
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _objectSpread(_objectSpread({}, INITIAL_STATE), CUSTOM_STATE);
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    switch (action.type) {
      case "".concat(ADDRESS_ID, "_").concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".FAILED"):
      case "".concat(ADDRESS_ID, "_").concat(_addressSearchActionConstants.LOQATE_ADDRESS_SELECT, ".FAILED"):
        {
          return _objectSpread(_objectSpread({}, state), {}, {
            addressSearchComplete: true,
            showAddressForm: true,
            showAddressSearchForm: false,
            findAddressError: ADDRESS_SEARCH_ERROR,
            initialValues: {
              countryCode: 'GB'
            }
          });
        }
      case "".concat(ADDRESS_ID, "_").concat(_addressActionConstants.SELECT_ADDRESS):
        {
          var address = action.address,
            replaceGbTerritoryCountryCodes = action.replaceGbTerritoryCountryCodes;
          var parsedAddress = Object.keys(address).reduce(function (acc, key) {
            return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, address[key]));
          }, {});

          // TODO When MARV-5897 is resolved this countryCode overwriting can be removed
          // Correct place to do this is in ATG, not on the client
          var nonGbBritishCountryCodes = ['GG', 'IM', 'JE'];
          if (replaceGbTerritoryCountryCodes && (!parsedAddress.countryCode || parsedAddress.countryCode === '' || nonGbBritishCountryCodes.indexOf(address.countryCode) >= 0)) {
            parsedAddress.countryCode = 'GB';
          }
          return _objectSpread(_objectSpread({}, state), {}, {
            showAddressSearchForm: false,
            showAddressForm: true,
            initialValues: parsedAddress
          });
        }
      case "".concat(ADDRESS_ID, "_").concat(_addressActionConstants.ENTER_MANUAL_ADDRESS):
        return _objectSpread(_objectSpread({}, state), {}, {
          findAddressError: undefined,
          showAddressSearchForm: false,
          showAddressForm: true,
          internationalMode: action.international,
          initialValues: action.international ? {
            countryCode: action.countryCode || '',
            phoneNumberCountryCode: action.countryCode || 'GB'
          } : {
            countryCode: 'GB',
            phoneNumberCountryCode: 'GB'
          }
        });
      case "".concat(ADDRESS_ID, "_").concat(_addressActionConstants.RESET_ADDRESS_SEARCH):
        return {
          addressSearchComplete: false,
          addresses: [],
          findAddressError: undefined,
          showAddressForm: false,
          showAddressSearchForm: true,
          internationalMode: false,
          initialValues: action.countryCode ? {
            countryCode: action.countryCode,
            phoneNumberCountryCode: action.countryCode
          } : undefined
        };
      case "".concat(ADDRESS_ID, "_").concat(_addressActionConstants.RESET_FIND_ADDRESS_ERROR):
        return _objectSpread(_objectSpread({}, state), {}, {
          findAddressError: undefined
        });
      case '@@router/LOCATION_CHANGE':
        return _objectSpread(_objectSpread({}, state), {}, {
          findAddressError: undefined
        });
      default:
        return state;
    }
  };
};
var _default = exports["default"] = addressHigherOrderReducer;